module.exports = __webpack_public_path__ + "static/media/data-storage.37ed6147.svg";